import * as constants from '@/store/constants'

export const initialState = () => ({
    userId: null,
    username: null,
    token: null,
    permission: null,
    agencyId: 0,
    agencyName: null,
    firstname: null,
    lastname: null,
    agencyOthers: null,
    notificationId: 0,
    requestTypeId: 0,    
    purposeId: 0,
    purposeOthers: null,
    detailsNotification: null,
    map: null,
    waypoints: [],
    ehocRef: null,
    centcomRef: null,
    nv_for: null,
    nv_number: null,
    request_date: null,
    requestedBy: 0,
    lastUpdatedBy: 0,
    notes: null,
    statusId: 0,
    notes: null,
    purposeList: null,
    agencyList: null,
    requestTypeList: null,
    emergencyNotificationList: null,
    statusList: null,
    //photos: [],
    //mode: constants.MODE_NEW,
    modified: false,
    map_modified: false,
    map_index: 0,
    viewMofa: false,
    start_date: null,
    // departure_date: null,
    // arrival_date: null,
    // air
    usageList: [],
    clearanceList: [],
    requestList: [],    
    operatorList: [],    
    // nsl
    facilityTypeList: [],
    siteTypeList: [],
    attachmentList: [],
    userList: [],
    new_notification: false,
    totalRows: 0,
    isMofaCompleted: false,
    isFormCompleted: false,
    isOrgAnonymous: false,
    submittedId: 0,
})

export const intitialStateUser = () => ({
    user: {
        id: 0,
        firstname: null,
        lastname: null,
        agency_id: 0,
        username: null,
        credential: null,
        created_date: null,
        updated_date: null,
        email_address: null,
        position: null,
        phone: null,
        active: null  
     }   
})

export const initialStateLandMovement = () => ({    
    convoys: [],
    participants: [],
    vehicles: [],
    trucks: [],
    photos: []
})

export const initialStateTempVenue = () => ({
    venues: []
})

export const initialStateSea = () => ({
    sea: {
        telephone_no: null,
        mobile_no: null,
        boat_name: null,
        flag: null,
        type_commerce: null
        //members: []     
    }
})

export const initialStateMofa = () => ({
    land: {
        id: 0,
        //notification_id: 0,
        //agency_id: 0,
        start_date: null,
        end_date: null,
        // request_type_id: 0,
        vehicle_type: null,
        no_vehicle: null,
        route: null,
        cargo_details: null,
        cargo_type: null,
        distribution_plan: null,
        initial_beneficiary: null,
        beneficiaries: null,
        quantity_weight: null
    },
    centcom: {
        id: 0,
        //notification_id: 0,
        //agency_id: 0,
        start_date: null,
        end_date: null,
        // request_type_id: 0,
        vehicle_type: null,
        no_vehicle: null,
        route: null,
        cargo_details: null,
        cargo_type: null,
        distribution_plan: null,
        initial_beneficiary: null,
        beneficiaries: null,
        quantity_weight: null
    },
    air: {
        id: 0,
        //notification_id;
        //agency_id;
        travel_date: null,
        aircraft_signal_call: null,
        registration_no: null,
        landing_permit_no: null,
        leasing_company: null,
        aircraft_type: null,
        // request_type_id: 0,
        icao_route: null,
        flight_itinerary: null,
        cargo_details: null,
        other: null
    },
    temp: {
        id: 0,
        //notification_id:0
        //agency_id:0
        start_date: null,
        end_date: null,
        //request_type_id: 0,
        venue_type: null,
        location: null,
        purpose: null,
        distribution_plan: null,
        initial_beneficiary: null,
        beneficiaries: null
    },
    nsl: {
        id: 0,
        //notification_id: 0,
        //agency_id:0,
        travel_date: null,
        //request_type_id: 0,
        vehicle_type: null,
        route: null,
        cargo_details: null,
        cargo_type: null,
        distribution_plan: null,
        initial_beneficiary: null,
        beneficiaries: null
    },
    sea: {
        id: 0,
        //notification_id: 0,
        //agency_id: 0,
        travel_date: null,
        vessels_name: null,
        imo: null,
        call_sign: null,
        vessels_flag: null,
        registered_port: null,
        // request_type_id: 0,
        vessels_type: null,
        vstate_thuraya: null,
        vessels_itinerary: null,    
        cargo_details: null,
        other: null
    }
})

export const initialStateAir = () => ({  
    data: {
        id: 0,
        military_clear_order: false,
        aviation_notice:  false,
        diplomatic_clear_order: false,
        ambulance_clear_order: false,
        type_clearance: [],
        type_request: [],
        aircraft_usage: null,
        aircraft_usage_other: null,
        aircraft_type: null,
        aircraft_operator: 0,
        aircraft_operator_other: null,
        aircraft_reg: null,
        aircraft_call_sign: null,
        date_flight: null,
        purpose_flight: null,
        route_flight: null,
        vip_name_rank: null,
        vip_sponsor_party: null,
        vip_arrival: null,
        vip_depart: null,
        ship_name_cargo: null,
        ship_consignee: null,
        ship_consignor: null,
        sup_annual: null,
        sup_gen_remarks: null
    }      
})

export const initialStateNSL = () => ({    
    nslList: []
})


export const initialStateNotification = () => ({
    notificationList: [],
    dashboard_statistics: []  
})

export const USER = 'USER'
export const ADMIN = 'ADMIN'
export const SUPER_ADMIN = 'SUPER_ADMIN'

export const MODE_NEW = 'NEW'
export const MODE_EDIT = 'EDIT'

export const FORM_ADMIN_LETTERS = 1
export const FORM_AIR = 2
export const FORM_LAND_MOVEMENT = 3
export const FORM_SEA = 5
export const FORM_TEMP_VENUE = 6
export const FORM_NO_STRIKE_LIST = 4

// AIR TYPES
export const AIR_TYPE_CLEARANCE = 1
export const AIR_TYPE_REQUEST = 2
export const AIR_TYPE_USAGE = 3
export const AIR_TYPE_OPERATOR = 4

// NOTIFICATION STATUS
//export const STATUS_CANCEL = 1
//export const STATUS_POSTPONE = 2
//export const STATUS_ACKNOWLEDGED = 3
//export const STATUS_INUSE = 13
//export const STATUS_SUBMITTED = 14

export const STATUS_AGENCY_CANCELLED = 1
export const STATUS_AGENCY_POSTPONED = 2
export const STATUS_ACKNOWLEDGED = 3
export const STATUS_ADMIN_NOTE_VERBALE = 4
export const STATUS_NO_EHOC_RESPONSE_PROVIDED = 5
export const STATUS_NO_TIME_FOR_EHOC_TO_PROCESS = 6
export const STATUS_PENDING_EHOC_RESPONSE = 7
export const STATUS_PENDING_AGENCY_AMENDMENT = 8
export const STATUS_RETURNED = 9
export const STATUS_SUBMITTED_TO_EHOC = 10
export const STATUS_UNDER_PROCESSING_BY_DLT = 11
export const STATUS_WAS_NOT_RECEIVED_BY_EHOC_TECHNICAL_ISSUE = 12
export const STATUS_INUSE = 13
export const STATUS_SENT_TO_DLT = 14
export const STATUS_EHOC_RESPONSE_PROVIDED = 15
export const STATUS_NO_AGENCY_RESPONSE = 16
export const STATUS_EHOC_SYSTEM_DOWN = 17
export const STATUS_NA_ADMIN = 18
export const STATUS_NO_EHOC_CLEARANCE = 19
export const STATUS_EXPIRED = 20
export const SUBMITTED_CENTCOM = 21
export const SUBMITTED_EHOC_CENTCOM = 22

export const STATUS_COLOR_CODES = [
        {id: STATUS_AGENCY_CANCELLED, color: "#dc3545"},
        {id: STATUS_AGENCY_POSTPONED, color: "#ffc107"},
        {id: STATUS_ACKNOWLEDGED, color: "#28a745"},
        {id: STATUS_ADMIN_NOTE_VERBALE, color: "#f4a460"},
        {id: STATUS_NO_EHOC_RESPONSE_PROVIDED, color: "#d2b48c"},
        {id: STATUS_NO_TIME_FOR_EHOC_TO_PROCESS, color: "#87ceeb"},
        {id: STATUS_PENDING_EHOC_RESPONSE, color: "#00ffff"},
        {id: STATUS_PENDING_AGENCY_AMENDMENT, color: "#c0c0c0"},
        {id: STATUS_RETURNED, color: "#800080"},
        {id: STATUS_SUBMITTED_TO_EHOC, color: "#007bff"},
        {id: STATUS_UNDER_PROCESSING_BY_DLT, color: "#00ff00"},
        {id: STATUS_WAS_NOT_RECEIVED_BY_EHOC_TECHNICAL_ISSUE, color: "#708090"},
        {id: STATUS_INUSE, color: "#868e96"},
        {id: STATUS_SENT_TO_DLT, color: "#17a2b8"},
        {id: STATUS_EHOC_RESPONSE_PROVIDED, color: "#ff00ff"},
        {id: STATUS_NO_AGENCY_RESPONSE, color: "#66c2a4" },
        {id: STATUS_EHOC_SYSTEM_DOWN, color: "#238b45" },
        {id: STATUS_NA_ADMIN, color: "#41ae76" },
        {id: STATUS_NO_EHOC_CLEARANCE, color: "#9ebcda" },
        {id: STATUS_EXPIRED, color: "#32ba91" },
        {id: SUBMITTED_CENTCOM, color: "#18ffff" },
        {id: SUBMITTED_EHOC_CENTCOM, color: "#00b8d4" }

]

// DLT EMAIL
// export const EMAIL_DLT = "dcyemen@un.org"

export const EMAIL_DLT = "EMAIL_DLT"
//export const EMAIL_DLT = "abdulghani@un.org,mekki@un.org,hijazia@un.org,adham.tbeil@un.org,delvin.arsan@un.org"
//export const EMAIL_DLT = "jimjaspe@gmail.com"
// "dcyemen@un.org"


export const TZ_ASIA_RIYADH = "Asia/Riyadh"
export const TZ_ASIA_TAIPEI = "Asia/Taipei"


// PURPOSE
export const PURPOSE_OTHERS = 15

// AGENCY
export const AGENCY_OTHERS = 22
export const AGENCY_ADMIN = 0

// DATE LOCAL
export const DATE_LOCALE_EN = {
        dow: 7, // Sunday is the first day of the week
        hourTip: 'Select Hour', // tip of select hour
        minuteTip: 'Select Minute', // tip of select minute
        secondTip: 'Select Second', // tip of select second
        yearSuffix: '', // suffix of head
        monthsHead: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), // months of head
        months: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), // months of panel
        weeks: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), // weeks,
        cancelTip: 'Cancel', // text for cancel button for daterange picker
        submitTip: 'Submit' // text for submit button for daterange picker
      }

// MAXIMUM UPLOAD FILE SIZE 
export const FILE_MAXIMUM_SIZE = 1048576



// WEBPACK FOOTER //
// ./src/store/constants.js